import React from 'react';

function SideSocial() {
    return (
        <div className="side-social">
            <a href="https://www.facebook.com/profile.php?id=61585363281245" target="_blank" rel="noopener noreferrer">FB</a>
            <a href="https://www.instagram.com/raimbowcraft.ae/?igsh=c2VtcDlvdjFjYnQy&utm_source=qr#://instagram.com" target="_blank" rel="noopener noreferrer">Insta</a>
            <a href="https://www.linkedin.com/company/rainbow-craft/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
    );
}

export default SideSocial;
